import folderSaga from './folderSaga';
import projectSaga from './projectSaga';

export default () => [...folderSaga(), ...projectSaga()];
